<template>
  <v-container id="about" tag="section">
    <base-subheading>Freek</base-subheading>

    <p>Ter nagedachtenis van Freek Veerhoek opdat we hem niet vergeten. Diegene die hem hebben ontmoet, zullen zijn geraakt door zijn persoonlijkheid. Aan de hand van foto’s proberen we die momenten te herinneren en te delen.</p>
  </v-container>
</template>

<script>
export default {
  name: "HomeAbout"
};
</script>
